module.exports = __webpack_public_path__ + "static/img/PFK_Photo2_StoryBegins_2000x500.34e2ecb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_Photo2_StoryBegins_2000x500.jpg
// module id = 333
// module chunks = 2